import { EventEmitter, Injectable, Injector, Output } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject } from 'rxjs';

export interface MessageEvent {
  title?: string;
  body?: string;
  type?: string;
  code?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  args?: any;
  autoclear?: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class ScrServiceManager {

  public static injector?: Injector = undefined;

  @Output() outstandingRequestCount = new EventEmitter<number>();

  outstandingRequests = 0;

  private message = new BehaviorSubject<MessageEvent>({});
  currentMsg = this.message.asObservable();
  private _nobusy = false;
  private debug = false;

  constructor(inj: Injector, private logger: NGXLogger) {
    ScrServiceManager.injector = inj;
  }

  public set nobusy(nb: boolean) {
    if (this.debug) { console.debug('set no busy ' + nb); }
    this._nobusy = nb;
  }

  public get nobusy(): boolean {
    return this._nobusy;
  }

  emitChange(change: MessageEvent) {
    this.message.next(change);
  }

  /**
   * Set the number of outstanding requests (such as HTTP requests).  This is
   * useful in deciding when to show and hide the busy indicator on the web app.
   * @deprecated a new HTTP interceptor replaces this allowing the application code to be independant
   * @param out - number of outstanding requests
  */
  setOutstanding(out: number) {
    this.outstandingRequests = out;
    this.outstandingRequestCount.emit(out);
  }
}


